import { Link, useNavigate } from "react-router-dom";

export function PlaceholderPage({ eyebrow, title, detail }: { eyebrow: string; title: string; detail: string }) {
  const navigate = useNavigate();
  return (
    <section className="placeholder-view">
      <div>
        <span>{eyebrow}</span>
        <h2>{title}</h2>
        <p>{detail}</p>
        {title === "More" && (
          <p className="placeholder-links"><Link to="/look-ahead">Look Ahead</Link> · <Link to="/horizon">Horizon</Link></p>
        )}
        <button onClick={() => navigate("/today")}>Return to Today</button>
      </div>
    </section>
  );
}
